import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/vc/acs'
  },
  {
    path: '/vc/acs/',
    name: 'ACS',
    props: true,
    component: () => import(/* webpackChunkName: "ACS" */ '../views/ACS.vue')
  },
  {
    path: '/vc/acs/:teamslink',
    name: 'ACS',
    props: true,
    component: () => import(/* webpackChunkName: "ACS" */ '../views/ACS.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
